<template>
    <pending-invitations />
</template>

<script>
import PendingInvitations from './PendingInvitations.vue';

export default {
    components: {
        PendingInvitations,
    },
};
</script>
